import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';

interface TemplateState {
  value: string;
}

// Define the initial state using that type
const initialState: TemplateState = {
  value: '',
};

/// THUNKS

export const fetchSomethingAsync = createAsyncThunk(
  'template/getSomethingAsync',
  async (val, { rejectWithValue, getState }) => {
    console.log('[Template] getSomethingAsync');
    try {
      const data = await setTimeout(() => { }, 1000);
      return data;
    } catch (err: any) {
      return rejectWithValue({ message: err.message });
    }
  }
);

/// SLICE

export const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {
    test: (state, action: PayloadAction<string>) => {
      console.log('[Template] test');
      state.value = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSomethingAsync.fulfilled, (state, action) => {
      console.log('[Template] fetchSomethingAsync.fulfilled');
      state.value = '';
    });
  },
});

/// REDUCERS

export const { test } = templateSlice.actions;

/// SELECTORS

export const selectTemplate = (state: RootState) => state.template.value;

export default templateSlice.reducer;
